<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
    <div class="container-header-inner">
        <div class="row">
            <div class="col-12 mb-4">
                <div class="title-wrapper">
                    <div>
                        <h1 class="title-default">{{ isEdicao ? 'Editar Forma de Recebimento' : 'Cadastrar Forma de
                            Recebimento' }}</h1>
                        <p class="welcome-message">
                            <button mat-icon-button (click)="voltar()">
                                <mat-icon>arrow_back</mat-icon>
                            </button>
                            {{ isEdicao ? 'Edite os dados da forma de recebimento.' : 'Cadastre uma nova forma de
                            recebimento.' }}
                        </p>
                    </div>
                </div>
            </div>

            @if (isLoading) {
            <div class="col-12">
                <app-loading-box height="220"></app-loading-box>
            </div>
            } @else {
            <div class="col-12">
                <form [formGroup]="form">
                    <div class="section-container">
                        <div class="section-title">
                            <mat-icon>payments</mat-icon>
                            <span>Informações da Forma de Recebimento</span>
                        </div>

                        <div class="row">
                            <div class="col-12">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Descrição</mat-label>
                                    <input matInput formControlName="descricao"
                                        placeholder="Digite a descrição da forma de recebimento">
                                    @if (form.get('descricao')?.hasError('required')) {
                                    <mat-error>A descrição é obrigatória.</mat-error>
                                    }
                                </mat-form-field>
                            </div>

                            <div class="col-md-6 col-12">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Situação</mat-label>
                                    <mat-select formControlName="isAtivo">
                                        <mat-option [value]="true">Habilitado</mat-option>
                                        <mat-option [value]="false">Desabilitado</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <div class="col-md-6 col-12">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>
                                        Validar Limite de Crédito
                                        <mat-icon class="tooltip-icon"
                                            matTooltip="Indica se as parcelas desta forma de recebimento serão validadas quanto ao limite de crédito e consideradas para calcular as contas atrasadas na venda">info_outline</mat-icon>
                                    </mat-label>
                                    <mat-select formControlName="isValidarLimiteCredito">
                                        <mat-option [value]="true">Validar</mat-option>
                                        <mat-option [value]="false">Não Validar</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            @if (exibeMeiosPagamentoNFe()) {
                            <div class="col-md-6 col-12">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Meios de pagamento NF-e</mat-label>
                                    <mat-select formControlName="idMeiosPagamentoNFe">
                                        @for (meio of meiosPagamentoNFeDisponiveis; track meio.id) {
                                        <mat-option [value]="meio.id">{{ meio.codigoSefaz }} - {{ meio.nome
                                            }}</mat-option>
                                        }
                                    </mat-select>
                                    @if (form.get('idMeiosPagamentoNFe')?.hasError('required')) {
                                    <mat-error>Selecione um meio de pagamento NF-e.</mat-error>
                                    }
                                </mat-form-field>
                            </div>
                            }
                        </div>
                    </div>

                    @if (exibeDestinoValores()) {
                    <div class="section-container">
                        <div class="section-title">
                            <mat-icon>account_tree</mat-icon>
                            <span>Destino dos valores recebidos</span>
                        </div>

                        <div class="row">
                            <div class="col-md-6 col-12">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Destino</mat-label>
                                    <mat-select formControlName="idTipoDestino">
                                        @for (destino of tiposDestinoDisponiveis; track destino.id) {
                                        <mat-option [value]="destino.id">{{ destino.descricao }}</mat-option>
                                        }
                                    </mat-select>
                                    @if (form.get('idTipoDestino')?.hasError('required')) {
                                    <mat-error>Selecione o destino dos valores.</mat-error>
                                    }
                                </mat-form-field>
                            </div>

                            @if (isDestinoContaFinanceiraSelecionado()) {
                            <div class="col-md-6 col-12">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Conta financeira</mat-label>
                                    <mat-select formControlName="idContaFinanceira">
                                        @for (conta of contasFinanceirasDisponiveis; track
                                        getContaFinanceiraLookupId(conta))
                                        {
                                        <mat-option [value]="getContaFinanceiraLookupId(conta)">{{ conta.descricao
                                            }}</mat-option>
                                        }
                                    </mat-select>
                                    @if (form.get('idContaFinanceira')?.hasError('required')) {
                                    <mat-error>Selecione uma conta financeira.</mat-error>
                                    }
                                </mat-form-field>
                            </div>
                            }
                        </div>

                        @if (!tiposDestinoDisponiveis.length) {
                        <p class="lookup-empty-message">Nenhum destino disponível para esta forma de recebimento.</p>
                        }
                    </div>
                    }

                    @if (exibeConfiguracoesAdicionais()) {
                    <div class="section-container">
                        <div class="section-title">
                            <mat-icon>tune</mat-icon>
                            <span>Configurações adicionais</span>
                        </div>

                        <div class="sub-section-container">
                            <h3 class="sub-section-title">
                                <mat-icon>percent</mat-icon>
                                <span>Tarifação e taxas</span>
                            </h3>
                            <div class="row">
                                <div class="col-md-6 col-12">
                                    <mat-form-field appearance="outline" class="w-100">
                                        <mat-label>Tarifação</mat-label>
                                        <mat-select formControlName="idTipoTarifacao">
                                            @for (tipoTarifacao of tiposTarifacaoDisponiveis; track tipoTarifacao.id) {
                                            <mat-option [value]="tipoTarifacao.id">{{ tipoTarifacao.descricao
                                                }}</mat-option>
                                            }
                                        </mat-select>
                                        @if (form.get('idTipoTarifacao')?.hasError('required')) {
                                        <mat-error>Selecione o tipo de tarifação.</mat-error>
                                        }
                                    </mat-form-field>
                                </div>

                                @if (exibeCampoDiaTarifa()) {
                                <div class="col-md-6 col-12">
                                    <mat-form-field appearance="outline" class="w-100">
                                        <mat-label>Dia</mat-label>
                                        <input matInput type="number" min="1" max="31" step="1"
                                            formControlName="diaTarifa" class="no-spinner" placeholder="Informe o dia">
                                        @if (form.get('diaTarifa')?.hasError('required')) {
                                        <mat-error>Preenchimento obrigatório.</mat-error>
                                        } @else if (form.get('diaTarifa')?.hasError('min') ||
                                        form.get('diaTarifa')?.hasError('max')) {
                                        <mat-error>O valor mínimo é 1 e o máximo é 31.</mat-error>
                                        } @else if (form.get('diaTarifa')?.hasError('pattern')) {
                                        <mat-error>Deve ser um número inteiro.</mat-error>
                                        }
                                        <mat-hint>Dia do mês (1 a 31)</mat-hint>
                                    </mat-form-field>
                                </div>
                                }

                                @if (exibeCamposTarifaDetalhados()) {
                                <div class="col-md-6 col-12">
                                    <mat-form-field appearance="outline" class="w-100">
                                        <mat-label>Categoria para as tarifas</mat-label>
                                        <mat-select formControlName="idCategoriaFinanceira">
                                            @for (categoria of categoriasTarifaDisponiveis; track categoria.id) {
                                            <mat-option [value]="categoria.id">{{ categoria.descricao }}</mat-option>
                                            }
                                        </mat-select>
                                        @if (form.get('idCategoriaFinanceira')?.hasError('required')) {
                                        <mat-error>Selecione a categoria para as tarifas.</mat-error>
                                        }
                                    </mat-form-field>
                                </div>

                                <div class="col-md-4 col-12">
                                    <mat-form-field appearance="outline" class="w-100">
                                        <mat-label>Tarifa fixa por transação (R$)</mat-label>
                                        <input matInput formControlName="tarifaFixa" placeholder="0,00" currencyMask
                                            [options]="moneyMask">
                                        @if (form.get('tarifaFixa')?.hasError('required')) {
                                        <mat-error>Preenchimento obrigatório.</mat-error>
                                        }
                                    </mat-form-field>
                                </div>

                                <div class="col-md-4 col-12">
                                    <mat-form-field appearance="outline" class="w-100">
                                        <mat-label>Taxa da transação (%)</mat-label>
                                        <input matInput formControlName="taxaTransacao" placeholder="0,00"
                                            [currencyMask]="getDecimalMask(2)">
                                        @if (form.get('taxaTransacao')?.hasError('required')) {
                                        <mat-error>Preenchimento obrigatório.</mat-error>
                                        }
                                    </mat-form-field>
                                </div>

                                <div class="col-md-4 col-12">
                                    <mat-form-field appearance="outline" class="w-100">
                                        <mat-label>Taxa adicional por parcela (%)</mat-label>
                                        <input matInput formControlName="taxaAdicionalParcela" placeholder="0,00"
                                            [currencyMask]="getDecimalMask(2)">
                                        @if (form.get('taxaAdicionalParcela')?.hasError('required')) {
                                        <mat-error>Preenchimento obrigatório.</mat-error>
                                        }
                                        <mat-hint>Apenas para pagamentos com mais de uma parcela</mat-hint>
                                    </mat-form-field>
                                </div>
                                }
                            </div>
                        </div>

                        <div class="sub-section-container">
                            <h3 class="sub-section-title">
                                <mat-icon>trending_up</mat-icon>
                                <span>Antecipação de recebíveis</span>
                            </h3>
                            <div class="row">
                                <div class="col-md-6 col-12">
                                    <mat-form-field appearance="outline" class="w-100">
                                        <mat-label>
                                            Antecipação dos recebíveis
                                            <mat-icon class="tooltip-icon"
                                                matTooltip="Configura o recebimento antecipado dos valores.">info_outline</mat-icon>
                                        </mat-label>
                                        <mat-select formControlName="isAntecipacao">
                                            <mat-option [value]="false">Sem antecipação</mat-option>
                                            <mat-option [value]="true">Antecipado</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>

                                @if (exibeCamposAntecipacao()) {
                                <div class="col-md-6 col-12">
                                    <mat-form-field appearance="outline" class="w-100">
                                        <mat-label>Forma de cálculo das taxas</mat-label>
                                        <mat-select formControlName="idFormaCalculoTaxas">
                                            @for (formaCalculo of formasCalculoTaxasDisponiveis; track formaCalculo.id)
                                            {
                                            <mat-option [value]="formaCalculo.id">{{ formaCalculo.descricao
                                                }}</mat-option>
                                            }
                                        </mat-select>
                                        @if (form.get('idFormaCalculoTaxas')?.hasError('required')) {
                                        <mat-error>Selecione a forma de cálculo das taxas.</mat-error>
                                        }
                                    </mat-form-field>
                                </div>

                                <div class="col-md-6 col-12">
                                    <mat-form-field appearance="outline" class="w-100">
                                        <mat-label>Dias para recebimento</mat-label>
                                        <input matInput type="number" min="1" step="1" formControlName="diasRecebimento"
                                            class="no-spinner" placeholder="Informe os dias">
                                        @if (form.get('diasRecebimento')?.hasError('required')) {
                                        <mat-error>Preenchimento obrigatório.</mat-error>
                                        } @else if (form.get('diasRecebimento')?.hasError('min')) {
                                        <mat-error>Deve ser no mínimo 1.</mat-error>
                                        } @else if (form.get('diasRecebimento')?.hasError('pattern')) {
                                        <mat-error>Deve ser um número inteiro.</mat-error>
                                        }
                                        <mat-hint>Após data da operação</mat-hint>
                                    </mat-form-field>
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                    }
                    @if (isEdicao && exibeIntermediadoresDiretos()) {
                    <div class="section-container">
                        <div class="section-title">
                            <mat-icon>hub</mat-icon>
                            <span>Intermediadores de pagamento habilitados para este recebimento</span>
                        </div>
                        <p class="intermediador-subtitle">
                            Intermediadores de pagamento são os intermediários entre as operadoras de cartões e a sua
                            empresa. Exemplo: Cielo, Rede, etc...
                        </p>

                        @if (isLoading) {
                        <app-loading-box height="80"></app-loading-box>
                        } @else if (intermediadores.length === 0) {
                        <div class="intermediador-empty">
                            <mat-icon class="empty-icon">hub</mat-icon>
                            <p>Nenhum intermediador de pagamento cadastrado.</p>
                            <button mat-stroked-button color="primary"
                                routerLink="/configuracoes/financas/intermediador-pagamento/cadastrar">
                                <mat-icon>add</mat-icon>
                                Adicionar intermediador de pagamento
                            </button>
                        </div>
                        } @else {
                        <table mat-table [dataSource]="intermediadores" class="w-100 mb-3 boleto-table">
                            <ng-container matColumnDef="select">
                                <th mat-header-cell *matHeaderCellDef class="w-checkbox"></th>
                                <td mat-cell *matCellDef="let item" class="w-checkbox">
                                    <mat-checkbox color="primary" [checked]="item.isHabilitado"
                                        (change)="onHabilitadoChange(item, $event.checked)">
                                    </mat-checkbox>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="descricao">
                                <th mat-header-cell *matHeaderCellDef>Descrição</th>
                                <td mat-cell *matCellDef="let item">
                                    <div class="py-2">
                                        <strong>{{ item.descricao }}</strong><br>
                                        <small class="text-secondary">{{ item.descricaoAdquirente }}</small>
                                    </div>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="actions">
                                <th mat-header-cell *matHeaderCellDef class="text-end column-actions">Ações</th>
                                <td mat-cell *matCellDef="let item" class="text-end">
                                    <div class="action-buttons">
                                        @if (item.isHabilitado) {
                                        <button mat-icon-button matTooltip="Intermediador preferencial"
                                            (click)="setPreferencial(item)">
                                            @if (item.isPreferencial) {
                                            <mat-icon class="material-icons-outlined star-action-icon">star</mat-icon>
                                            } @else {
                                            <mat-icon
                                                class="material-icons-outlined star-action-icon">star_border</mat-icon>
                                            }
                                        </button>
                                        }
                                        <button type="button" mat-icon-button
                                            [routerLink]="['/configuracoes/financas/intermediador-pagamento/cadastrar', item.idIntermediadorPagamento]"
                                            matTooltip="Editar intermediador">
                                            <mat-icon class="material-symbols-outlined">edit</mat-icon>
                                        </button>
                                    </div>
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="['select', 'descricao', 'actions']"></tr>
                            <tr mat-row *matRowDef="let row; columns: ['select', 'descricao', 'actions'];"
                                [class.row-habilitado]="row.isHabilitado"></tr>
                        </table>

                        <div class="mt-4 pt-3">
                            <button type="button" mat-button
                                (click)="confirmarRedirecionamento('Intermediador', ['/configuracoes/financas/intermediador-pagamento/cadastrar'])">
                                adicionar intermediador
                            </button>
                        </div>
                        }
                    </div>
                    }

                    @if (isBoletoForm()) {
                    <div class="section-container">
                        <div class="section-title">
                            <mat-icon>account_balance</mat-icon>
                            <span>Contas bancárias e intermediadores</span>
                            <button type="button" mat-icon-button (click)="refreshDestinosBoleto()"
                                matTooltip="Atualizar lista">
                                <mat-icon>refresh</mat-icon>
                            </button>
                        </div>
                        <p class="intermediador-subtitle">
                            Informe aqui quais são as contas bancárias e intermediadores que você possui e estão
                            habilitados para boletos
                        </p>

                        @if (isLoadingDestinosBoleto || isLoading) {
                        <app-loading-box height="80"></app-loading-box>
                        } @else if (destinosBoleto.length === 0) {
                        <div class="intermediador-empty">
                            <mat-icon class="empty-icon">account_balance</mat-icon>
                            <p>Nenhuma conta bancária ou intermediador encontrado.</p>
                            <div class="d-flex gap-3 mt-3">
                                <button type="button" mat-stroked-button
                                    (click)="confirmarRedirecionamento('Conta Bancária', ['/configuracoes/financas/contas-financeiras/cadastrar'], { tipo: 'Bancaria' })">
                                    <mat-icon>add</mat-icon> Adicionar conta bancária
                                </button>
                                <button type="button" mat-stroked-button
                                    (click)="confirmarRedirecionamento('Intermediador', ['/configuracoes/financas/intermediador-pagamento/cadastrar'])">
                                    <mat-icon>add</mat-icon> Adicionar intermediador
                                </button>
                            </div>
                        </div>
                        } @else {
                        <table mat-table [dataSource]="destinosBoleto" class="w-100 mb-3 boleto-table">
                            <ng-container matColumnDef="select">
                                <th mat-header-cell *matHeaderCellDef class="w-checkbox"></th>
                                <td mat-cell *matCellDef="let item" class="w-checkbox">
                                    <mat-checkbox color="primary" [checked]="item.isHabilitado"
                                        (change)="onHabilitadoBoletoChange(item, $event.checked)">
                                    </mat-checkbox>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="descricao">
                                <th mat-header-cell *matHeaderCellDef> Banco ou Intermediador </th>
                                <td mat-cell *matCellDef="let item">
                                    <div class="py-2">
                                        <strong>{{ item.descricao }}</strong><br>
                                        <small class="text-secondary">{{ item.detalhe }}</small>
                                    </div>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="actions">
                                <th mat-header-cell *matHeaderCellDef class="text-end column-actions"> Ações </th>
                                <td mat-cell *matCellDef="let item" class="text-end">
                                    <div class="action-buttons">
                                        @if (item.isHabilitado) {
                                        <button mat-icon-button matTooltip="Intermediador preferencial"
                                            (click)="setPreferencialBoleto(item)">
                                            @if (item.isPreferencial) {
                                            <mat-icon class="material-icons-outlined star-action-icon">star</mat-icon>
                                            } @else {
                                            <mat-icon
                                                class="material-icons-outlined star-action-icon">star_border</mat-icon>
                                            }
                                        </button>
                                        }
                                        <button type="button" mat-icon-button matTooltip="Editar"
                                            (click)="confirmarRedirecionamento(item.descricao, getDestinoBoletoEditLink(item))">
                                            <mat-icon class="material-symbols-outlined">edit</mat-icon>
                                        </button>
                                    </div>
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="['select', 'descricao', 'actions']"></tr>
                            <tr mat-row *matRowDef="let row; columns: ['select', 'descricao', 'actions'];"
                                [class.row-habilitado]="row.isHabilitado"></tr>
                        </table>

                        <div class="mt-4 pt-3 d-flex gap-4">
                            <button type="button" mat-button
                                (click)="confirmarRedirecionamento('Conta bancária', ['/configuracoes/financas/contas-financeiras/cadastrar'], { tipo: 'Bancaria' })">
                                adicionar conta bancária
                            </button>
                            <button type="button" mat-button
                                (click)="confirmarRedirecionamento('Intermediador', ['/configuracoes/financas/intermediador-pagamento/cadastrar'])">
                                adicionar intermediador
                            </button>
                        </div>
                        }
                    </div>
                    }

                    @if (isDepositoForm()) {
                    <div class="section-container">
                        <div class="section-title">
                            <mat-icon>account_balance</mat-icon>
                            <span>Contas bancárias habilitadas para este recebimento</span>
                            <button type="button" mat-icon-button (click)="refreshDestinosBoleto()"
                                matTooltip="Atualizar lista">
                                <mat-icon>refresh</mat-icon>
                            </button>
                        </div>
                        <p class="intermediador-subtitle">
                            Informe aqui quais são as contas bancárias que você possui e estão habilitadas para
                            depósito.
                        </p>

                        @if (isLoadingDestinosBoleto || isLoading) {
                        <app-loading-box height="80"></app-loading-box>
                        } @else if (contasBancariasDeposito.length === 0) {
                        <div class="intermediador-empty">
                            <mat-icon class="empty-icon">account_balance</mat-icon>
                            <p>Nenhuma conta bancária encontrada.</p>
                            <button type="button" mat-stroked-button
                                (click)="confirmarRedirecionamento('Conta Bancária', ['/configuracoes/financas/contas-financeiras/cadastrar'], { tipo: 'Bancaria' })">
                                <mat-icon>add</mat-icon> Adicionar conta bancária
                            </button>
                        </div>
                        } @else {
                        <table mat-table [dataSource]="contasBancariasDeposito" class="w-100 mb-3 boleto-table">
                            <ng-container matColumnDef="select">
                                <th mat-header-cell *matHeaderCellDef class="w-checkbox"></th>
                                <td mat-cell *matCellDef="let item" class="w-checkbox">
                                    <mat-checkbox color="primary" [checked]="item.isHabilitado"
                                        (change)="onHabilitadoBoletoChange(item, $event.checked)">
                                    </mat-checkbox>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="descricao">
                                <th mat-header-cell *matHeaderCellDef> Conta bancária </th>
                                <td mat-cell *matCellDef="let item">
                                    <div class="py-2">
                                        <strong>{{ item.descricao }}</strong><br>
                                        <small class="text-secondary">{{ item.detalhe }}</small>
                                    </div>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="actions">
                                <th mat-header-cell *matHeaderCellDef class="text-end column-actions"> Ações </th>
                                <td mat-cell *matCellDef="let item" class="text-end">
                                    <div class="action-buttons">
                                        @if (item.isHabilitado) {
                                        <button mat-icon-button matTooltip="Conta bancária preferencial"
                                            (click)="setPreferencialBoleto(item)">
                                            @if (item.isPreferencial) {
                                            <mat-icon class="material-icons-outlined star-action-icon">star</mat-icon>
                                            } @else {
                                            <mat-icon
                                                class="material-icons-outlined star-action-icon">star_border</mat-icon>
                                            }
                                        </button>
                                        }
                                        <button type="button" mat-icon-button matTooltip="Editar"
                                            (click)="confirmarRedirecionamento(item.descricao, getDestinoBoletoEditLink(item))">
                                            <mat-icon class="material-symbols-outlined">edit</mat-icon>
                                        </button>
                                    </div>
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="['select', 'descricao', 'actions']"></tr>
                            <tr mat-row *matRowDef="let row; columns: ['select', 'descricao', 'actions'];"
                                [class.row-habilitado]="row.isHabilitado"></tr>
                        </table>

                        <div class="mt-4 pt-3 d-flex gap-4">
                            <button type="button" mat-button
                                (click)="confirmarRedirecionamento('Conta bancária', ['/configuracoes/financas/contas-financeiras/cadastrar'], { tipo: 'Bancaria' })">
                                adicionar conta bancária
                            </button>
                        </div>
                        }
                    </div>
                    }


                    @if (isPixForm()) {
                    <div class="section-container">
                        <div class="section-title">
                            <mat-icon>account_balance</mat-icon>
                            <span>Contas bancárias e intermediadores</span>
                            <button type="button" mat-icon-button (click)="refreshDestinosBoleto()"
                                matTooltip="Atualizar lista">
                                <mat-icon>refresh</mat-icon>
                            </button>
                        </div>
                        <p class="intermediador-subtitle">
                            Informe aqui quais são as contas bancárias e intermediadores que você possui e estão
                            habilitados para PIX
                        </p>

                        @if (isLoadingDestinosBoleto || isLoading) {
                        <app-loading-box height="80"></app-loading-box>
                        } @else if (destinosBoleto.length === 0) {
                        <div class="intermediador-empty">
                            <mat-icon class="empty-icon">account_balance</mat-icon>
                            <p>Nenhuma conta bancária ou intermediador encontrado.</p>
                            <div class="d-flex gap-3 mt-3">
                                <button type="button" mat-stroked-button
                                    (click)="confirmarRedirecionamento('Conta Bancária', ['/configuracoes/financas/contas-financeiras/cadastrar'], { tipo: 'Bancaria' })">
                                    <mat-icon>add</mat-icon> Adicionar conta bancária
                                </button>
                                <button type="button" mat-stroked-button
                                    (click)="confirmarRedirecionamento('Intermediador', ['/configuracoes/financas/intermediador-pagamento/cadastrar'])">
                                    <mat-icon>add</mat-icon> Adicionar intermediador
                                </button>
                            </div>
                        </div>
                        } @else {
                        <table mat-table [dataSource]="destinosBoleto" class="w-100 mb-3 boleto-table">
                            <ng-container matColumnDef="select">
                                <th mat-header-cell *matHeaderCellDef class="w-checkbox"></th>
                                <td mat-cell *matCellDef="let item" class="w-checkbox">
                                    <mat-checkbox color="primary" [checked]="item.isHabilitado"
                                        (change)="onHabilitadoBoletoChange(item, $event.checked)">
                                    </mat-checkbox>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="descricao">
                                <th mat-header-cell *matHeaderCellDef> Banco ou Intermediador </th>
                                <td mat-cell *matCellDef="let item">
                                    <div class="py-2">
                                        <strong>{{ item.descricao }}</strong><br>
                                        <small class="text-secondary">{{ item.detalhe }}</small>
                                    </div>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="actions">
                                <th mat-header-cell *matHeaderCellDef class="text-end column-actions"> Ações </th>
                                <td mat-cell *matCellDef="let item" class="text-end">
                                    <div class="action-buttons">
                                        @if (item.isHabilitado) {
                                        <button mat-icon-button matTooltip="Intermediador preferencial"
                                            (click)="setPreferencialBoleto(item)">
                                            @if (item.isPreferencial) {
                                            <mat-icon class="material-icons-outlined star-action-icon">star</mat-icon>
                                            } @else {
                                            <mat-icon
                                                class="material-icons-outlined star-action-icon">star_border</mat-icon>
                                            }
                                        </button>
                                        }
                                        <button type="button" mat-icon-button matTooltip="Editar"
                                            (click)="confirmarRedirecionamento(item.descricao, getDestinoBoletoEditLink(item))">
                                            <mat-icon class="material-symbols-outlined">edit</mat-icon>
                                        </button>
                                    </div>
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="['select', 'descricao', 'actions']"></tr>
                            <tr mat-row *matRowDef="let row; columns: ['select', 'descricao', 'actions'];"
                                [class.row-habilitado]="row.isHabilitado"></tr>
                        </table>

                        <div class="mt-4 pt-3 d-flex gap-4">
                            <button type="button" mat-button
                                (click)="confirmarRedirecionamento('Conta bancária', ['/configuracoes/financas/contas-financeiras/cadastrar'], { tipo: 'Bancaria' })">
                                adicionar conta bancária
                            </button>
                            <button type="button" mat-button
                                (click)="confirmarRedirecionamento('Intermediador', ['/configuracoes/financas/intermediador-pagamento/cadastrar'])">
                                adicionar intermediador
                            </button>
                        </div>
                        }
                    </div>
                    }

                    @if (isCrediarioSelecionado()) {
                    <div class="section-container">
                        <div class="section-title">
                            <mat-icon>request_quote</mat-icon>
                            <span>Dados de Cobrança</span>
                        </div>

                        <div class="row">
                            <div class="col-12 cobranca-toggle-col">
                                <div class="cobranca-toggle-content">
                                    <mat-slide-toggle class="app-toggle-compact" formControlName="hasJurosMulta">
                                        Calcular juros e multas após o vencimento
                                    </mat-slide-toggle>
                                    <span class="info-text text-muted">As taxas serão aplicadas quando você receber
                                        pagamentos atrasados.</span>
                                </div>
                            </div>

                            @if (form.get('hasJurosMulta')?.value) {
                            <div class="col-md-4 col-12">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>% Juros (ao dia)</mat-label>
                                    <input matInput formControlName="percentualJurosDiario" placeholder="ex: 0,10"
                                        [currencyMask]="getDecimalMask(3)">
                                    @if (form.get('percentualJurosDiario')?.hasError('required')) {
                                    <mat-error>Preenchimento obrigatório.</mat-error>
                                    }
                                    @if (form.get('percentualJurosDiario')?.hasError('min') ||
                                    form.get('percentualJurosDiario')?.hasError('max')) {
                                    <mat-error>Deve ser entre 0 e 100%.</mat-error>
                                    }
                                </mat-form-field>
                            </div>

                            <div class="col-md-4 col-12">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>% de multa</mat-label>
                                    <input matInput formControlName="percentualMultaMensal" placeholder="ex: 2,00"
                                        [currencyMask]="getDecimalMask(2)">
                                    @if (form.get('percentualMultaMensal')?.hasError('required')) {
                                    <mat-error>Preenchimento obrigatório.</mat-error>
                                    }
                                    @if (form.get('percentualMultaMensal')?.hasError('min') ||
                                    form.get('percentualMultaMensal')?.hasError('max')) {
                                    <mat-error>Deve ser entre 0 e 100%.</mat-error>
                                    }
                                </mat-form-field>
                            </div>

                            <div class="col-md-4 col-12">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Nº de dias para multa</mat-label>
                                    <input matInput type="number" min="0" step="1" formControlName="diasCarenciaMulta"
                                        class="no-spinner" placeholder="ex: 5">
                                    @if (form.get('diasCarenciaMulta')?.hasError('required')) {
                                    <mat-error>Preenchimento obrigatório.</mat-error>
                                    }
                                    @if (form.get('diasCarenciaMulta')?.hasError('min')) {
                                    <mat-error>Deve ser no mínimo 0.</mat-error>
                                    }
                                    @if (form.get('diasCarenciaMulta')?.hasError('pattern')) {
                                    <mat-error>Deve ser um número inteiro.</mat-error>
                                    }
                                </mat-form-field>
                            </div>
                            }
                        </div>
                    </div>
                    }
                </form>
            </div>
            }
        </div>
    </div>
</div>

<app-footer-action [isLoadingSalvar]="isSaving" [isSalvarDisabled]="isLoading" (cancelar)="voltar()"
    (salvar)="salvar()">
</app-footer-action>